<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_50",
      next: "P_52",
      review: "P_46",
      topic: "Estás en: Taller ¿Qué es crédito? / ¿Qué aprendí en esta lección?",
      progress: false,
      questions: 6
    };
  },
  methods: {
    recordScore() {
      this.progress = true;
      eventBus.$emit("record_score", evaluation);
    },
    evaluation_bak() {
      var quiz_prefix = "page10-";
      var quiz_results = Object.keys(this.$parent.results)
        .filter(key => key.indexOf(quiz_prefix) > -1)
        .reduce((obj, key) => {
          obj[key] = this.$parent.results[key];
          return obj;
        }, {});
      return (
        (100 / this.questions) *
        Object.values(quiz_results).reduce((a, b) => a + b, 0)
      ).toFixed(0);
    },
    evaluation() {
      let sum = 0;
      sum += this.$parent.results["P_46"];
      console.log("P_46:" + sum);
      sum += this.$parent.results["P_47"];
      console.log("P_47:" + sum);
      sum += this.$parent.results["P_48"];
      console.log("P_48:" + sum);
      sum += this.$parent.results["P_49"];
      console.log("P_49:" + sum);
      sum += this.$parent.results["P_50"];
      console.log("P_50:" + sum);
      sum /= 6;
      console.log("avg:" + sum);
      sum *= 100;
      console.log("avg x 100:" + sum);
      return sum.toFixed(0);
    }
  }
};
</script>

<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat, text-xs-center)
            breadcrumb(:back='last') {{topic}}
            v-layout.px-4(row, justify-start)
              v-flex(xs6)
                v-card(flat)
                  v-img(height='576px', :src='require("@/assets/TCC-L9-Pagina6 A.png")')
              v-flex(xs6)
                v-card.ml-0.pl-0(flat, text-xs-start)
                  v-card-text.label16tt.withDividerLeft.ml-0.pl-0(style='color:#F7893B')
                    | RESULTADO FINAL
                  v-card-text.titulo60Book.ml-0.pl-0
                    | {{evaluation()}}/100
                  v-btn.btn.ml-0.pl-0(type='button', color='secondary', @click.prevent="lastPage(review)")
                    | Revisar
                  div(v-if='60<=evaluation()')
                    v-card-text.titulo36Book.pt-5.ml-0.pl-0
                      b ¡Excelente!
                    v-card-text.parrafoDestacado18.ml-0.pl-0
                      | ¡Muchas Felicidades! Todo indica que has adquirido los conocimientos y habilidades más relevantes de 
                      b  Conoce el Crédito.
                    v-card-text.parrafoDestacado18.ml-0.pl-0
                      a(:href='this.$parent.enlace'  target="_blank") Conoce más
                  div
                    v-card-text.parrafoDestacado18.ml-0.pl-0
                      | Te recomendamos repasar una vez más Conoce el Crédito para tener una mejor experiencia de aprendizaje.
                    v-card-text.parrafoDestacado18.ml-0.pl-0
                      div También puedes, si lo consideras conveniente, conocer más sobre créditos en 
                        a(:href='this.$parent.enlace'  target="_blank") esta liga 
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button ', color='primary ', @click.prevent="nextPage(next)")
                | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>


